import http from "./axios_config.js";
import qs from "qs";

const randomPassword = (length) => {
  length = Number(length);
  //密码最低为10位
  if (length < 10) {
    length = 10;
    //最长为20位
  } else if (length > 20) {
    length = 20;
  }
  let passwordArray = [
    "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
    "abcdefghijklmnopqrstuvwxyz",
    "1234567890",
    "_!@#$%^&*()?.~",
  ];
  var password = [];
  let n = 0;
  for (let i = 0; i < length; i++) {
    // If password length less than 9, all value random
    if (password.length < length - 4) {
      // Get random passwordArray index
      let arrayRandom = Math.floor(Math.random() * 4);
      // Get password array value
      let passwordItem = passwordArray[arrayRandom];
      // Get password array value random index
      // Get random real value
      let item = passwordItem[Math.floor(Math.random() * passwordItem.length)];
      password.push(item);
    } else {
      // If password large then 9, lastest 4 password will push in according to the random password index
      // Get the array values sequentially
      let newItem = passwordArray[n];
      let lastItem = newItem[Math.floor(Math.random() * newItem.length)];
      // Get array splice index
      let spliceIndex = Math.floor(Math.random() * password.length);
      password.splice(spliceIndex, 0, lastItem);
      n++;
    }
  }
  return password.join("");
};

/* eslint-disable */
const hidePhone = (phone) => {
  var newphone = phone;
  if (phone && phone.length == 11) {
    newphone = phone.replace(phone.substring(3, 7), "****");
  }
  return newphone;
};

const hideName = (name) => {
  var newname = "******";
  if (name && name.length >= 1) {
    newname = name.substring(0, 1) + "***";
  }
  return newname;
};

//在数组中查询指定数据
const searchByRegExp = (keyWord, list, itemNameList) => {
  if (!(list instanceof Array)) {
    return;
  }
  var len = list.length;
  var arr = [];
  var reg = new RegExp(keyWord);
  for (var i = 0; i < len; i++) {
    // 如果字符串中不包含目标字符会返回-1
    var item = list[i];
    itemNameList.split(",").forEach((j) => {
      if (item[j].match(reg)) {
        arr.push(item);
      }
    });
  }
  return arr;
};

/**
 * 获取用户权限
 * @returns 权限数组
 */
const getAdminRights = () => {
  var rightsStorage = window.localStorage.getItem("adminRights");
  if (!rightsStorage) return null;
  var adminRights = JSON.parse(rightsStorage);
  return Array.isArray(adminRights) ? adminRights : null;
};

//获取权限
const getRight = (classFullName, rightCode) => {
  const rightsArray = getAdminRights();
  //兼容更新后未重新获取权限的情况
  if (!rightsArray || rightsArray.length <= 0) return true;

  // 校验权限
  const rightsCheck = (v, rightCode) => {
    var right = v.Rights.find((z) => z.RightCode == rightCode);
    return right && right.IsRight;
  };

  // 未传入rightCode，则classFullName为rightCode
  return !rightCode
    ? rightsArray.some((v) => rightsCheck(v, classFullName))
    : rightsArray.some(
      (v) => v.ClassFullName == classFullName && rightsCheck(v, rightCode)
    );
};

// 获取用户配置
const getAdminUserConfig = (key) => {
  let adminUserConfig = JSON.parse(localStorage.getItem("adminUserConfig"));
  if (!adminUserConfig || !adminUserConfig.length) return []; // 本地无数据
  let configItem = adminUserConfig.filter((item) => item.ConfigKey === key);
  if (!configItem.length) return []; // 无匹配数据
  return JSON.parse(configItem[0].ConfigValue);
};

// 时间戳转日期时间
const timestampToTime = (timestamp) => {
  var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  var Y = date.getFullYear() + "-";
  var M =
    (date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1) + "-";
  var D = (date.getDate() < 10 ? "0" : "") + date.getDate() + " ";
  var h = (date.getHours() < 10 ? "0" : "") + date.getHours() + ":";
  var m = (date.getMinutes() < 10 ? "0" : "") + date.getMinutes() + ":";
  var s = (date.getSeconds() < 10 ? "0" : "") + date.getSeconds();

  return Y + M + D + h + m + s;
};
//对象复制
const cloneObj = (obj) => {
  let newObj = {};
  if (obj instanceof Array) {
    newObj = [];
  }
  for (let key in obj) {
    let val = obj[key];
    //newObj[key] = typeof val === 'object' ? arguments.callee(val) : val; //arguments.callee 在哪一个函数中运行，它就代表哪个函数, 一般用在匿名函数中。
    newObj[key] = typeof val === "object" ? cloneObj(val) : val;
  }
  return newObj;
};

const loadScript = (path, callback) => {
  var script = document.createElement("script");
  script.type = "text/javascript";
  if (typeof callback != "undefined") {
    if (script.readyState) {
      script.onreadystatechange = function () {
        if (script.readyState == "loaded" || script.readyState == "complete") {
          script.onreadystatechange = null;
          callback();
        }
      };
    } else {
      script.onload = function () {
        callback();
      };
    }
  }
  script.src = path;
  document.body.appendChild(script);
};

//获取系统参数
const getSysParams = (code) => {
  let value = null;
  if (Array.isArray(JSON.parse(window.localStorage.getItem("adminParams")))) {
    JSON.parse(window.localStorage.getItem("adminParams")).forEach(function (
      v
    ) {
      if (v.ParamCode == code) {
        value = v.ParamValue == "" ? v.DefaultValue : v.ParamValue;
        return false;
      }
    });
  }
  return value;
};
//证件校验
const checkCardNo = (CardNo, CodeSign) => {
  //身份证验证
  if (CodeSign == 1) {
    CardNo = CardNo.toUpperCase();
    if (!isCardNo(CardNo)) {
      return "你输入的身份证号码数字验证错误,请重新输入";
    }
    // 检查省份
    if (!checkProvince(CardNo)) {
      return "您输入的身份证号码省份不正确,请重新输入";
    }
    // 校验生日
    if (!checkBirthday(CardNo)) {
      return "您输入的身份证号码生日不正确,请重新输入";
    }
    // 检验位的检测
    if (!checkParity(CardNo)) {
      return "您输入身份证号码校验位不正确,请重新输入";
    }
    return "";
  }
  //港澳台验证
  if (CodeSign == 2) {
    if (!isEmpty(CardNo)) {
      return "证件号码不能为空,请重新输入";
    }
    // if (!isHKTWCard(CardNo)) {
    //     return '你输入的港澳台证件号码验证错误,请重新输入'
    // }
    return "";
  }
  //外籍证件验证
  if (CodeSign == 3) {
    if (!isEmpty(CardNo)) {
      return "证件号码不能为空,请重新输入";
    }
    // if (!isPassPortCard(CardNo)) {
    //     return '你输入的外籍护照证件号码验证错误,请重新输入'
    // }
    return "";
  }
  //其它验证
  if (CodeSign) {
    if (!isEmpty(CardNo)) {
      return "证件号码不能为空,请重新输入";
    }
    //其它证件暂未做限制
    return "";
  }
};

const isCardNo = (idcard) => {
  // 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X
  var reg = /(^\d{15}$)|(^\d{17}(\d|X)$)/;
  if (!reg.test(idcard)) {
    return false;
  }
  return true;
};

const checkProvince = (idcard) => {
  var vcity = {
    11: "北京",
    12: "天津",
    13: "河北",
    14: "山西",
    15: "内蒙古",
    21: "辽宁",
    22: "吉林",
    23: "黑龙江",
    31: "上海",
    32: "江苏",
    33: "浙江",
    34: "安徽",
    35: "福建",
    36: "江西",
    37: "山东",
    41: "河南",
    42: "湖北",
    43: "湖南",
    44: "广东",
    45: "广西",
    46: "海南",
    50: "重庆",
    51: "四川",
    52: "贵州",
    53: "云南",
    54: "西藏",
    61: "陕西",
    62: "甘肃",
    63: "青海",
    64: "宁夏",
    65: "新疆",
    71: "台湾",
    81: "香港",
    82: "澳门",
    91: "国外",
  };
  var province = idcard.substr(0, 2);
  if (vcity[province] === null) {
    return false;
  }
  return true;
};
// 检查生日是否正确
const checkBirthday = (idcard) => {
  var len = idcard.length;
  // 身份证15位时，次序为省（3位）市（3位）年（2位）月（2位）日（2位）校验位（3位），皆为数字
  if (len === 15) {
    var re_fifteen = /^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/;
    var arr_data = idcard.match(re_fifteen);
    var year = arr_data[2];
    var month = arr_data[3];
    var day = arr_data[4];
    var birthday = new Date("19" + year + "/" + month + "/" + day);
    return verifyBirthday("19" + year, month, day, birthday);
  }
  // 身份证18位时，次序为省（3位）市（3位）年（4位）月（2位）日（2位）校验位（4位），校验位末尾可能为X
  if (len === 18) {
    var re_eighteen = /^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/;
    var arr_data2 = idcard.match(re_eighteen);
    var year2 = arr_data2[2];
    var month2 = arr_data2[3];
    var day2 = arr_data2[4];
    var birthday2 = new Date(year2 + "/" + month2 + "/" + day2);
    return verifyBirthday(year2, month2, day2, birthday2);
  }
  return false;
};
// 校验日期
const verifyBirthday = (year, month, day, birthday) => {
  var now = new Date();
  var now_year = now.getFullYear();
  // 年月日是否合理
  if (
    birthday.getFullYear() == year &&
    birthday.getMonth() + 1 == month &&
    birthday.getDate() == day
  ) {
    // 判断年份的范围（0岁到120岁之间)
    var time = now_year - year;
    if (time >= 0 && time <= 120) {
      return true;
    }
    return false;
  }
  return false;
};
// 校验位的检测
const checkParity = (idcard) => {
  // 15位转18位
  idcard = changeFivteenToEighteen(idcard);
  var len = idcard.length;
  if (len === 18) {
    var arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2);
    var arrCh = new Array(
      "1",
      "0",
      "X",
      "9",
      "8",
      "7",
      "6",
      "5",
      "4",
      "3",
      "2"
    );
    var cardTemp = 0;
    var i;
    var valnum;
    for (i = 0; i < 17; i++) {
      cardTemp += idcard.substr(i, 1) * arrInt[i];
    }
    valnum = arrCh[cardTemp % 11];
    if (valnum == idcard.substr(17, 1)) {
      return true;
    }
    return false;
  }
  return false;
};
// 15位转18位身份证号
const changeFivteenToEighteen = (idcard) => {
  if (idcard.length === 15) {
    var arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2);
    var arrCh = new Array(
      "1",
      "0",
      "X",
      "9",
      "8",
      "7",
      "6",
      "5",
      "4",
      "3",
      "2"
    );
    var cardTemp = 0;
    var i;
    idcard = idcard.substr(0, 6) + "19" + idcard.substr(6, idcard.length - 6);
    for (i = 0; i < 17; i++) {
      cardTemp += idcard.substr(i, 1) * arrInt[i];
    }
    idcard += arrCh[cardTemp % 11];
    return idcard;
  }
  return idcard;
};
//港澳台证件校验
const isHKTWCard = (card) => {
  // 港澳居民来往内地通行证
  // 规则： H/M + 10位或6位数字
  // 样本： H1234567890
  var reg = /^([A-Z]\d{6,10}(\(\w{1}\))?)$/;

  // 台湾居民来往大陆通行证
  // 规则： 新版8位或18位数字， 旧版10位数字 + 英文字母
  // 样本： 12345678 或 1234567890B
  var reg2 = /^\d{8}|^[a-zA-Z0-9]{10}|^\d{18}$/;
  if (reg.test(card) === false && reg2.test(card) === false) {
    return false;
  }
  return true;
};
//护照校验
const isPassPortCard = (card) => {
  // 护照
  // 规则： 14/15开头 + 7位数字, G + 8位数字, P + 7位数字, S/D + 7或8位数字,等
  // 样本： 141234567, G12345678, P1234567
  var reg = /^([a-zA-z]|[0-9]){5,17}$/;
  if (reg.test(card) === false) {
    return false;
  } else {
    return true;
  }
};
//军官证校验
const isOfficerCard = (card) => {
  // 军官证
  // 规则： 军/兵/士/文/职/广/（其他中文） + "字第" + 4到8位字母或数字 + "号"
  // 样本： 军字第2001988号, 士字第P011816X号
  var reg = /^[\u4E00-\u9FA5](字第)([0-9a-zA-Z]{4,8})(号?)$/;
  if (reg.test(card) === false) {
    return false;
  } else {
    return true;
  }
};
//户口本号码校验
const isAccountCard = (card) => {
  // 户口本
  // 规则： 15位数字, 18位数字, 17位数字 + X
  // 样本： 441421999707223115
  var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
  if (reg.test(card) === false) {
    return false;
  } else {
    return true;
  }
};
//手机号码正则校验
const isPhone = (phone) => {
  // 第一段是大陆手机号，第二段是香港，第三段是澳门
  var reg = /^[1]\d{10}$|^853[6]\d{7}$|^852[5|6|9]\d{7}$/;
  if (!reg.test(phone)) {
    return false;
  } else {
    return true;
  }
};
//姓名正则校验
const isName = (name) => {
  //var reg = /(^[\u4e00-\u9fa5]{1}[\u4e00-\u9fa5\.·。]{0,8}[\u4e00-\u9fa5]{1}$)|(^[a-zA-Z]{1}[a-zA-Z\s]{0,8}[a-zA-Z]{1}$)/;
  var reg = /^[\u4E00-\u9FA5\uf900-\ufa2d·s]{2,20}$|^[a-zA-Z]{1,30}$/gi; // 允许英文30个字母 或者2-20个汉字
  //var reg = /^[\u4E00-\u9FA5\uf900-\ufa2d·s]{2,20}$/;//验证姓名正则
  if (reg.test(name) === false) {
    return false;
  } else {
    return true;
  }
};
// 车牌号的正则表达式
const isCarNo = (CarNo) => {
  if (!CarNo) {
    return false;
  }
  if (CarNo.length == 7) {
    // 车牌号判断的正则表达式
    var regExp = /(^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1}$)/;
    if (!regExp.test(CarNo)) {
      return false;
    }
  } else {
    // 新能源车牌号校验
    var xreg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-HJ-NP-Z][A-HJ-NP-Z0-9]{4,5}[A-HJ-NP-Z0-9挂学警港澳]$/;
    //var xreg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[DF]$)|([DF][A-HJ-NP-Z0-9][0-9]{4}$))/;
    if (!xreg.test(CarNo)) {
      return false;
    }
  }
  return true;
};
//非空判断
const isEmpty = (value) => {
  var reg = /\S/;
  return reg.test(value);
};

const getIsWxClient = () => {
  var ua = navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    return true;
  }
  return false;
};

const setWXConfig = () => {
  // "https://wx.open.class.busboss.cn/Weixin/JSAPI"   "https://wxcs.busboss.cn/Weixin/JSAPI"
  return new Promise((resolve, reject) => {
    http
      .post(
        "https://wx.open.class.busboss.cn/Weixin/JSAPI",
        qs.stringify({
          url: encodeURIComponent(window.location.href.split("#")[0]),
          AppID: "wx5e2cde762ffa2228",
        })
      )
      .then(function (t) {
        if (t) {
          // eslint-disable-next-line no-undef
          wx.config({
            debug: !1,
            // debug: 1,
            appId: t.appId,
            timestamp: parseInt(t.timestamp),
            nonceStr: t.noncestr,
            signature: t.signature,
            jsApiList: ["scanQRCode", "getLocation"],
          });
        }
        console.log("setWXConfig:success", t);
        resolve(t);
      })
      .catch((err) => {
        console.log("setWXConfig:err", err);
        reject(err);
      });
  });
};

const scanQRCode = (func) => {
  return new Promise((resolve, reject) => {
    //调起摄像头扫码
    if (window.framework && window.framework.jsCameraScan) {
      if (typeof func == "function") {
        func.bind(this);
      }
      window.framework.jsCameraScan();
    }
    // 判断微信内置浏览器
    else if (getIsWxClient()) {
      wx.ready(() => {
        wx.scanQRCode({
          needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
          scanType: ["qrCode"], // 可以指定扫二维码还是一维码，默认二者都有
          success: function (codeRes) {
            var qrCode = codeRes.resultStr; // 当needResult 为 1 时，扫码返回的结果
            console.log("scanQRCode:success", codeRes, qrCode);
            resolve(codeRes);
          },
          fail: (err) => {
            console.log("scanQRCode:err", err);
            reject(err);
          },
        });
      });
    } else {
      reject("调起扫码失败，请检查设备！");
    }
  });
};

// 操作本地数据
const localData = {
  typeMap: new Map([
    [Boolean.name, (value) => (value === "true" ? true : false)],
    [String.name, (value) => value],
    [Object.name, (value) => JSON.parse(value)],
  ]),
  get(name, constructor) {
    return this.typeMap.get(constructor.name)(localStorage.getItem(name));
  },
  set(name, data) {
    return localStorage.setItem(name, data);
  },
};

const utils = {
  hidePhone: hidePhone,
  hideName: hideName,
  timestampToTime: timestampToTime,
  cloneObj: cloneObj,
  getSysParams: getSysParams,
  checkCardNo: checkCardNo,
  isPhone: isPhone,
  isAccountCard: isAccountCard,
  isOfficerCard: isOfficerCard,
  isName: isName,
  isEmpty: isEmpty,
  isCarNo: isCarNo,
  isCardNo: isCardNo,
  loadScript: loadScript,
  getRight: getRight,
  searchByRegExp: searchByRegExp,
  getIsWxClient: getIsWxClient,
  setWXConfig: setWXConfig,
  scanQRCode: scanQRCode,
  randomPassword: randomPassword,
  localData,
  getAdminUserConfig,
};

export default utils;
